/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { LoggerModule } from "@vlinder-web/logger-module-react";
import axios, { AxiosInstance } from "axios";
import toast from "react-hot-toast";
import { DEFAULT_APP_CONFIG } from "../config/default.config";

const MODULE_NAME = "SignUpService";
const log: any = LoggerModule.getInstance();

interface ISignUpProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

export class SignUpService {
    private baseUrl: string = DEFAULT_APP_CONFIG?.servers?.services?.baseUrl

    private static instance: SignUpService;
    private api: AxiosInstance;
    private termsLink: string;
    private constructor(props: ISignUpProps | any) {
        console.log(`base url inside constructor`, this.baseUrl);
        this.termsLink = props.termsLink;
        this.api = axios.create({
            baseURL: this.baseUrl,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...(props.headers || {}) },
            },
        });
    }
    public static getInstance(props: ISignUpProps | any = {}): SignUpService {
        if (!SignUpService.instance) {
            SignUpService.instance = new SignUpService(props);
        }
        return SignUpService.instance;
    }
    async mailSignUp({ email, password }: { email: string; password: string }) {
        try {
            log?.blue(MODULE_NAME, "email : ", email);
            console.log(email, password);
            const res = await this.api.post(`/signup`, {
                credentials: {
                    email,
                    password,
                    verifyAuthType: "tokenURL",
                },
            });
            log.blue(MODULE_NAME, "sign up success", res.data);
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in creating user",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async mailSignIn({ email, password }: { email: string; password: string }) {
        try {
            log?.blue(MODULE_NAME, "email : ", email);
            const res = await this.api.post(`/signin`, {
                email,
                password,
            });
            log.blue(MODULE_NAME, "sign in success", res.data);
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in signing in",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async verifyEmail({ email, otp }: { email: string; otp: string }) {
        try {
            log?.blue("email : ", email);
            const res = await this.api.get(
                `/verify_email_by_otp/${email}/${otp}`
            );
            log.blue(MODULE_NAME, "verify email success", res.data);
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in vrifying email",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async resetPassword({
        email,
        verifyAuthType,
    }: {
        email: string;
        verifyAuthType: string;
    }) {
        try {
            log?.blue("email : ", email);
            const res = await this.api.post(`/reset_password`, {
                email,
                verifyAuthType,
            });
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in reset Password",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async onChangePass({
        email,
        otp,
        password,
    }: {
        email: string;
        otp: string;
        password: string;
    }) {
        try {
            log?.blue("base url in change password", this.api.baseURL);
            const res = await this.api.post(`/change_password`, {
                email,
                otp,
                password,
                //token: ""
            });
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in reset Password",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async socialSignin({
        provider,
        baseURL,
    }: {
        provider: string;
        baseURL: string;
    }) {
        let pathArray = baseURL.split("/");
        let protocol = pathArray[0];
        let host = pathArray[2];
        let url = protocol + "//" + host;
        try {
            log?.blue(MODULE_NAME, "provider : ", provider);
            window.location.href = `${url}/connect/${provider}`;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in reset Password",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    async mailSignUpWithEmail({
        email,
        country,
        acceptTerms,
        password,
        token,
    }: {
        email: string;
        country: string;
        password: string;
        token: string;
    }) {
        log?.blue(MODULE_NAME, "email : ", email, token);
        try {
            log?.blue("email : ", email);
            const res = await this.api.post(`/change_password`, {
                email,
                nationality: country,

                terms_accepted: acceptTerms,
                password,
                token,
                service_agreement: this.termsLink,
            });
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in reset Password",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }

    
    async resendVerifyEmail({ email }: { email: string}) {
        try {
            log?.blue("resend email : ", email);
            const res = await this.api.post(
                `/resend_verification_email`,{email}
            );
            log.blue(MODULE_NAME, "resending verify email success", res.data);
            return res;
        } catch (err) {
            log?.error(
                MODULE_NAME,
                "Error in resending email",
                err?.response?.data?.error?.display_message
            );
            throw Error(err?.response?.data?.error?.display_message);
        }
    }
}
